module.exports = __webpack_public_path__ + "c00f66cbbb1f0411a6cae3fe476c84a2.pdf";